import React from "react";
import sponser1 from "../../Assets/Images/sponser1.png";
import sponser2 from "../../Assets/Images/sponser2.png";
import sponser3 from "../../Assets/Images/sponser3.png";
import sponser4 from "../../Assets/Images/sponser4.png";
import "./style.css";
export default function Footer() {
  return (
    <>
      <div className="footer-container">
        <div className="footer-header">
          <h2 style={{ color: "white" }}>Proudly Affiliated with</h2>
        </div>
        <div className="footer-sponser">
          {/* <div className="sponser-image"> */}
          <img className="" src={sponser3} alt="sponser" />
          {/* </div> */}
          {/* <div className="sponser-image"> */}
          <img className="" src={sponser4} alt="sponser" />
          {/* </div> */}
          {/* <div className="sponser-image"> */}
          <img className="" src={sponser2} alt="sponser" />
          {/* </div> */}
          {/* <div className="sponser-image"> */}
          <img className="" src={sponser1} alt="sponser" />
          {/* </div> */}
        </div>
      </div>
    </>
  );
}
